"use client";
import dynamic from "next/dynamic";

const LoginModal = dynamic(() => import("@/components/Login"), { ssr: false });
const RegisterModal = dynamic(() => import("@/components/Register"), { ssr: false });

/**
 * Shared login/sign-up modal orchestration for partner white-label storefronts.
 *
 * Both the desktop header (PartnerAccountButton) and the mobile bottom bar
 * (PartnerMobileBar) need the same auth modals, wired so the customer STAYS on
 * the storefront afterwards:
 *  - LoginModal closes in place for returning users (it never redirects itself).
 *  - RegisterModal redirects a brand-new user to `location` once profile setup
 *    completes; passing the storefront path keeps them inside the white-label
 *    experience instead of bouncing to the global /user/dashboard.
 *
 * Modals are dynamically imported (ssr:false) to match the rest of the app and
 * avoid shipping/hydrating auth UI until it is actually opened. Rendering nothing
 * until opened means this is inert on first paint (no CWV cost).
 */
const PartnerAuthModals = ({
  isLoginModalOpen,
  setIsLoginModalOpen,
  isRegisterModalOpen,
  setIsRegisterModalOpen,
  loginType,
  setLoginType,
  location,
}) => (
  <>
    {isLoginModalOpen && (
      <LoginModal
        setIsLoginModalOpen={setIsLoginModalOpen}
        setIsRegisterModalOpen={setIsRegisterModalOpen}
        setLoginType={setLoginType}
        location={location}
      />
    )}
    {isRegisterModalOpen && (
      <RegisterModal
        setIsRegisterModalOpen={setIsRegisterModalOpen}
        loginType={loginType}
        location={location}
      />
    )}
  </>
);

export default PartnerAuthModals;
